(ns manage.adset.view.page-header
  (:require ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Typography$default" :as Typography]
            ["src/svg/editor/objects/link.svg$default" :as LinkIcon]
            ["src/svg/location/map-marker-outlined.svg$default" :as MapMarker]
            ["src/svg/objects/calendar.svg$default" :as Calendar]
            ["src/svg/objects/target.svg$default" :as Target]
            [cljs-bean.core :refer [->clj]]
            [clojure.string :as str]
            [common.flags :refer [use-flag]]
            [common.patterns.stats-daterange-select :refer [recent-stats-daterange]]
            [common.queries :refer [use-queries use-query]]
            [common.resource.query.adset :as q]
            [common.resource.query.social-settings :as social-settings]
            [common.util :as util]
            [common.widgets.page :as page]
            [lemonpi.specs.interface.adset :refer [country-code-to-country-name]]
            [manage.ad-variant.creation.link.hooks :as link-hooks]
            [manage.adset-table.view :refer [enrich-status format-status]]
            [manage.adset.view.menu :as adset-menu]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui render-countries [{:keys [countries]}]
  ($ Stack
     {:direction "row"
      :alignItems "center"
      :gap 0.5}
     ($ SvgIcon {:inheritViewBox true}
        ($ MapMarker))
     ($ Typography {:sx #js {:textTransform "capitalize"}}
        (->> countries
             (map country-code-to-country-name)
             (str/join ", ")))))

(defui render-dates [{:keys [plannedStart plannedEnd]}]
  ($ Stack
     {:direction "row"
      :alignItems "center"
      :gap 0.5}
     ($ SvgIcon {:inheritViewBox true}
        ($ Calendar))
     ($ :span
        (util/format-iso-string plannedStart "ll")
        " - "
        (util/format-iso-string plannedEnd "ll"))))

(defui render-target-impressions [{:keys [targetImpressions]}]
  ($ Stack
     {:direction "row"
      :alignItems "center"
      :gap 0.5}
     ($ SvgIcon {:inheritViewBox true}
        ($ Target))
     ($ :span
        (util/->locale-string targetImpressions))))

(defn get-adset-recent-stats [^js data id]
  (->> data
       ->clj
       (some (fn [{:keys [adset-id impressions]}]
               (when (= adset-id id)
                 {:impressions-recent impressions})))))

(defn combine-queries-results [^js results]
  (let [results (->clj results)
        [{adset :data} {recent-stats :data}] results]
    #js {:isPending (boolean (some :isPending results))
         :data (->> (cond-> adset
                      recent-stats (merge recent-stats))
                    enrich-status)}))

(defui automated-info [{:keys [channel autoApproveAdVariants]}]
  (let [automated-activation? (use-flag :automated-activation)
        {:keys [advertiser-id adset-id]} (use-subscribe [:url-context])
        {:keys [data]} (use-query
                        (social-settings/fetch-advertiser-adset-integration-settings
                         {:advertiser-id advertiser-id :adset-id adset-id :channel channel}))
        auto-publish? (when data (-> data ->clj :auto-publish))
        label (cond
                (and autoApproveAdVariants auto-publish?) "Automated publish and approval"
                auto-publish? "Automated publish"
                autoApproveAdVariants "Automated approval")]
    (when (and automated-activation? label)
      ($ Typography {:sx #js {:display "flex" :alignItems "center" :gap 0.5}}
         ($ Icon {:fontSize "small"} "check")
         label))))

(defui page-header
  [{:keys [tabs title buttons children]}]
  (let [{:keys [campaign-id adset-id]} (use-subscribe [:url-context])
        adset-query (q/adset-query {:adset-id adset-id})
        recent-stats-query (util/spread-obj (q/adsets-stats-query {:campaign-id campaign-id :daterange recent-stats-daterange})
                                            #js {:select #(get-adset-recent-stats % adset-id)})
        {{:keys [name countries plannedStart plannedEnd targetImpressions] :as adset} :data}
        (use-queries #js {:queries #js [adset-query recent-stats-query]
                          :combine combine-queries-results})
        {:keys [mapped-campaigns]} (link-hooks/use-ps-campaigns)]
    ($ page/page-header
       {:title (or title name)
        :tabs tabs
        :buttons ($ :<>
                    buttons
                    ($ adset-menu/menu adset))}
       ($ Stack
          {:direction "row"
           :alignItems "center"
           :gap 1.5}
          ($ format-status adset)
          (when (seq countries)
            ($ render-countries adset))
          (when (or plannedStart plannedEnd)
            ($ render-dates adset))
          (when targetImpressions
            ($ render-target-impressions adset))
          (when (seq mapped-campaigns)
            (for [c mapped-campaigns]
              ($ Chip
                 {:variant "subtle"
                  :color "primary"
                  :label (:name c)
                  :icon ($ LinkIcon)
                  :key (str "mapped-campaign-chip" (:id c))})))
          ($ automated-info adset))
       children)))
